import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    BoxProps,
    ChakraProps,
    HStack,
    Image,
    Link,
    MenuIcon,
    Popover,
    PopoverContent,
    PopoverTrigger,
    useColorMode,
    useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import placeholder from '../../assets/placeholder.png';
import blackPlaceHolder from '../../assets/blackPlaceHolder.png';
import { config } from '../../config/sidebar/config';
import { ArrowDownPurple } from '../../iZUMi-UI-toolkit/src/components/ArrowDownPurple/ArrowDownPurple';
import { MenuClose } from '../../iZUMi-UI-toolkit/src/components/Icons/MenuIcon/MenuClose';
import { a_display } from '../../iZUMi-UI-toolkit/src/style';
import { DropDownButton } from './DropDownButton/DropDownButton';
import { getColorThemeSelector } from '../../utils/funcs';
import useLayoutType from '../../hooks/useLayoutType';
import { LayoutStateEnum } from '../../state/models/pageLayout/pageLayout';
import _ from 'lodash';

type DropDownMenuProps = {
    variant?: string;
    buttonProps?: ChakraProps;
    menuListProps?: ChakraProps;
} & BoxProps;
export const DropDownMenu: React.FC<DropDownMenuProps> = (props) => {
    const { variant, buttonProps, menuListProps, ...rest } = props;
    const { isOpen, onOpen, onClose } = useDisclosure();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const history = useHistory();
    const layoutType = useLayoutType();
    const [btHoverId, setBtHoverId] = useState(-1);
    const buildConfig = () => {
        const newConfig = _.cloneDeep(config);
        if (newConfig.pages.length < 2) {
            return config;
        }

        return newConfig;
    };

    return variant === 'mobile' ? (
        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
            <PopoverTrigger>
                <Image
                    // as={IconButton}
                    boxSize={'30px'}
                    mr="18px"
                    bg="inherit"
                    _hover={{ background: 'inherit' }}
                    _active={{ background: 'inherit' }}
                    icon={isOpen ? <MenuClose /> : <MenuIcon />}
                ></Image>
            </PopoverTrigger>
            <PopoverContent bg="rgba(20, 2, 51, 0.87);">
                {config.pages.map((page: any) => {
                    const commonAttr = {
                        key: page.name,
                        img: page.img,
                    };
                    if (page.children.length === 0) {
                        return <DropDownButton {...commonAttr} page={page} />;
                    } else {
                        return (
                            <Accordion key={page.name} defaultIndex={[0]} allowMultiple={true}>
                                <AccordionItem bg="rgba(20, 2, 51, 0.87);" color="tertiary.50" border="1px solid #393357">
                                    <AccordionButton className={a_display} fontFamily="Gilroy-Bold !important" my="10px">
                                        <Box flex="1" textAlign="left">
                                            {page.name}
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                    <AccordionPanel pb={4}>
                                        {page.children.map((child: any) =>
                                            child.address?.startsWith('http') ? (
                                                <Link key={child.name + child.address} target="_blank" to={{ pathname: child.address }}>
                                                    <Box
                                                        display="block"
                                                        fontFamily="Gilroy"
                                                        fontSize="14px"
                                                        pt="13px"
                                                        mr="34px"
                                                        pl="27px"
                                                        pb="11px"
                                                        target="_blank"
                                                        color="tertiary.200"
                                                        _hover={{ background: '#7D68E6' }}
                                                        onClick={() => {
                                                            if (child.address && child.address.startsWith('http')) {
                                                                window.open(child.address);
                                                            } else {
                                                                history.push(child.address);
                                                            }
                                                        }}
                                                    >
                                                        {child.name}
                                                    </Box>
                                                </Link>
                                            ) : (
                                                <Link to={child.address as string} key={child.name + child.address}>
                                                    <Box
                                                        display="block"
                                                        fontSize="14px"
                                                        fontFamily="Gilroy"
                                                        pt="13px"
                                                        mr="34px"
                                                        pl="27px"
                                                        pb="11px"
                                                        //fontWeight="bold"
                                                        target="_blank"
                                                        color="tertiary.200"
                                                        _hover={{ background: '#7D68E6' }}
                                                        onClick={() => {
                                                            if (child.address && child.address.startsWith('http')) {
                                                                window.open(child.address);
                                                            } else {
                                                                history.push(child.address);
                                                            }
                                                        }}
                                                    >
                                                        {child.name}
                                                    </Box>
                                                </Link>
                                            )
                                        )}
                                    </AccordionPanel>
                                </AccordionItem>
                            </Accordion>
                        );
                    }
                })}
            </PopoverContent>
        </Popover>
    ) : (
        <HStack {...rest} spacing="44px">
            {buildConfig().pages.map((page: any, index: number) => {
                const hoverImg = <ArrowDownPurple />;
                const black = (
                    <Image
                        w="11px"
                        h="7px"
                        src={colorTheme(placeholder, blackPlaceHolder)}
                        fallbackSrc={colorTheme(placeholder, blackPlaceHolder)}
                    ></Image>
                );
                const img = btHoverId === index ? hoverImg : black;

                const commonAttr = {
                    key: page.name,
                    img: page.img,
                };

                if (page.children.length === 0) {
                    return <DropDownButton {...commonAttr} buttonProps={buttonProps} page={page} />;
                } else {
                    return (
                        <DropDownButton
                            {...commonAttr}
                            rightIcon={img ?? black}
                            buttonProps={buttonProps}
                            menuListProps={menuListProps ?? undefined}
                            page={page}
                            index={index}
                            setBtHoverId={setBtHoverId}
                        />
                    );
                }
            })}
        </HStack>
    );
};
